import { isStagingEnvironment } from '@/utils/environment-utils'

export const ANGEL_GUILD_PREMIUM_YEARLY_OFFER_ID = isStagingEnvironment() ? '1853' : '1841'
export const ANGEL_GUILD_PREMIUM_MONTHLY_OFFER_ID = isStagingEnvironment() ? '1821' : '1848'
export const ANGEL_GUILD_BASIC_MONTHLY_OFFER_ID = '1873'
export const ANGEL_GUILD_BASIC_MONTHLY_ADD_A_LINE_OFFER_ID = '29636'
export const ANGEL_GUILD_BASIC_YEARLY_OFFER_ID = '3169'
export const ANGEL_GUILD_BASIC_NO_ADS_MONTHLY_OFFER_ID = '14359'
export const ANGEL_GUILD_BASIC_NO_ADS_MONTHLY_ADD_A_LINE_OFFER_ID = '29635'
export const ANGEL_GUILD_BASIC_NO_ADS_YEARLY_OFFER_ID = '14361'
